import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";  // Import i18next

export default function ThankYouPage() {
  const { t } = useTranslation();  // Initialize translation function

  return (
    <div className="min-h-screen flex items-center justify-center bg-white">
      <div className="bg-green-100 p-8 rounded-2xl shadow-md text-center space-y-4">
        <h2 className="text-2xl font-bold text-green-700">{t('thank_you_page.thank_you')}</h2>
        <p className="text-gray-700">
          {t('thank_you_page.message')}
        </p>
        <Link
          to="/"
          className="inline-block mt-4 bg-emerald-600 text-white px-6 py-2 rounded-full hover:bg-emerald-700 transition"
        >
          {t('thank_you_page.back_to_home')}
        </Link>
      </div>
    </div>
  );
}
